import { Label } from "ui/components/label";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import useTableFilters from "@/hooks/useTableFilters";
import SelectStatus from "components/select/status";
import { Checkbox } from "ui/components/checkbox";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";
import UserCombobox from "components/directus/combobox/user";
import ProjectTagsCombobox from "components/directus/combobox/project-tags";
import ClientCombobox from "components/directus/combobox/client";
import CompanyCombobox from "components/directus/combobox/company";
import { PermissionGate } from "permissions/components/gate";










export default function ProjectFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      sales_coordinator: undefined,
      client: undefined,
      status: undefined,
      skills: undefined,
      _view_type: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <UserCombobox
        label="Project Coordinator"
        value={localFilters?.coordinator?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            coordinator: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        filter={EMPLOYEE_FILTERS.projects_coordinating}
        dependenton={isOpen}
      />

      <UserCombobox
        label="Account Manager"
        value={localFilters?.account_manager?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            account_manager: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        filter={EMPLOYEE_FILTERS.account_manager}
        dependenton={isOpen}
      />

      <UserCombobox
        label="Sales Coordinator"
        value={localFilters?.sales_coordinator?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            sales_coordinator: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        filter={EMPLOYEE_FILTERS.sales_coordinating}
        dependenton={isOpen}
      />

      <PermissionGate collection="clients" rule="read:*">
        <CompanyCombobox
          value={localFilters?.client?.company_id?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              client: selectedItem
                ? {
                  company_id: { _eq: selectedItem },
                  _eq: undefined,
                }
                : undefined,
            });
          }}
          dependenton={isOpen}
        />

        <ClientCombobox
          filter={
            localFilters?.client?.company_id?._eq
              ? { company_id: { _eq: localFilters.client.company_id._eq } }
              : {}
          }
          value={localFilters?.client?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              client: selectedItem
                ? {
                  ...localFilters?.client,
                  _eq: selectedItem,
                }
                : localFilters?.client?.company_id?._eq
                  ? {
                    company_id: { _eq: localFilters.client.company_id._eq },
                    _eq: undefined,
                  }
                  : undefined,
            });
          }}
          dependenton={isOpen}
        />
      </PermissionGate>

      <FilterWrapper label="Status">
        <SelectStatus
          collection="projects"
          value={localFilters?.status?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              status: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
        />
      </FilterWrapper>

      <ProjectTagsCombobox
        value={
          localFilters?.tags?.tag?._eq ||
          localFilters?.tags?.tags_id?._eq ||
          localFilters?.tags?._eq ||
          localFilters?.tags?.id?._eq
        }
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            tags: selectedItem
              ? { tag: { _eq: selectedItem } }
              : undefined,
          });
        }}
      />

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
